import semver from 'semver';

import { DeviceDescriptor } from './records';

const sortByName = (deviceA: DeviceDescriptor, deviceB: DeviceDescriptor): number => (
  deviceA.name?.localeCompare(deviceB.name)
);

const sortPrivateFirst = (deviceA: DeviceDescriptor, deviceB: DeviceDescriptor): number => {
  const isAPrivate = deviceA.isPrivateDevice();
  const isBPrivate = deviceB.isPrivateDevice();

  if (isAPrivate && isBPrivate) {
    return 0;
  }

  if (isAPrivate) {
    return -1;
  }

  if (isBPrivate) {
    return 1;
  }

  return 0;
};
const sortByOsVersion = (deviceA: DeviceDescriptor, deviceB: DeviceDescriptor): number => {
  const versionA = semver.coerce(deviceA.osVersion) ?? '0.0.0';
  const versionB = semver.coerce(deviceB.osVersion) ?? '0.0.0';

  if (semver.gt(versionA, versionB)) {
    return -1;
  }

  if (semver.lt(versionA, versionB)) {
    return 1;
  }

  return 0;
};

export default {
  sortByName,
  sortByOsVersion,
  sortPrivateFirst,
};
